import { padding } from "@mui/system";
import { useParams } from "react-router-dom";
import { useEffect, useState,useRef } from "react";
import axios from "axios";
import { Box, Grid2, Typography, useMediaQuery,Tooltip,LinearProgress,Button } from "@mui/material";
import Styles from "./AboutBlog.module.css";
import MoreBlogs from "./MoreBlogs";
import { backendHosts,apiUrl } from "../../../ui-utils/apiConfig";
import toc_svg from "../../../ui-utils/latestPics/toc_svg.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
export default function AboutBlog() {


  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const [htmlBody, setHtmlBody] = useState("");
  const [blogData, setBlogData] = useState("");
  const [toc, setToc] = useState([]);
  const [activeHeading, setActiveHeading] = useState(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const contentRef = useRef(null);
  const [isShareExpanded, setIsShareExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const isSmallScreen = useMediaQuery("(max-width:720px)");
  const isMediumScreen = useMediaQuery("(max-width:1000px)");
  const isLargeScreen = useMediaQuery("(min-width:1416px)");
  const isMobile = useMediaQuery("(max-width: 800px)");
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    const [blog, setBlog] = useState(null)
  const { blog_id } = useParams();
  console.log("bb", blog_id)

  useEffect(() => {
    const handleResize = () => setViewportHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tocMaxHeight = isLandscape ? viewportHeight * 0.8 : "auto"; // 70% of viewport height in landscape mode

    useEffect(() => {
      console.log("Route param blogId:", blog_id);

      if (blog_id) {
        const numericId = Number(blog_id.split("-")[0]);
            console.log("Extracted ID:", numericId);

            if (!isNaN(numericId)) {
                fetchBlogById(numericId);
            } else {
                console.warn("Invalid blogId format");
            }
        }
    }, [blog_id]);

    const fetchBlogById = async (id) => {
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getABlog}${id}`);
            if (response.data.status === 200) {
                setBlog(response.data.blog);
                setHtmlBody(response.data?.blog.blog_html);
                processHtml(response.data?.blog.blog_html);
            } else {
                console.warn("Blog not found");
            }
        } catch (error) {
            console.error("Error fetching blog:", error);
        }
      };


  // Process HTML to extract h1 tags and set unique IDs
  const processHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const headings = Array.from(doc.querySelectorAll("h1, h2, h3"));
    console.log("heading",headings)
    const newToc = headings.map((heading, index) => {
    const id = `heading-${index}`;
      console.log(id)
      heading.id = id;
      return {
        id,
        text: heading.textContent,
        tag: heading.tagName.toLowerCase(),
      };
    });

    setToc(newToc);
    setHtmlBody(doc.body.innerHTML);
  };

  // Smooth scrolling function
  const scrollToSection = (id) => {
    console.log("ID",id)
    setActiveHeading(`heading-${id}`);
    const element = document.getElementById(id);
    if (element) {
      const offset = isSmallScreen ? 100 : 120; // Adjust for header height
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
       window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    }
  };

  // Set up scroll event listener for progress bar and TOC highlighting
  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY;
        const progress = (scrollTop / (docHeight - windowHeight)) * 100;
        setScrollProgress(progress);
      }

      const headings = toc
        .map((item) => document.getElementById(item.id))
        .filter(Boolean);

      let active = null;
      const offset = isSmallScreen ? 100 : 120;

      // Check each heading's position relative to viewport
      for (let i = 0; i < headings.length; i++) {
        const heading = headings[i];
        const nextHeading = headings[i + 1];
        const rect = heading.getBoundingClientRect();
        const headingTop = rect.top + window.pageYOffset - offset;

        // If this is the last heading or we haven't scrolled to the next one yet
        if (
          !nextHeading ||
          window.pageYOffset <
          nextHeading.getBoundingClientRect().top +
          window.pageYOffset -
          offset
        ) {
          if (headingTop <= window.pageYOffset) {
            active = heading.id;
            break;
          }
        }
      }

      setActiveHeading(active);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [toc]);

    return (<main>

    <Grid2
    sx={{
      "&::-webkit-scrollbar": {
        width: "0",
        height: "0",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      scrollbarWidth: "none",
      msOverflowStyle: "none",
    }}
    >

      <>
        <Grid2
          sx={{
            backgroundColor: "#ffffff",
            mt: "72px",
            width: "100%",
            maxWidth: "100vw",
          }}
        >
          {/* Progress Bar */}
          <LinearProgress
            aria-label="Page loading progress"
            variant="determinate"
            value={scrollProgress}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              height: "5px",
              zIndex: 9999,
              backgroundColor: "transparent",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#3788F1",
              },
            }}
          />

          <Grid2
            sx={{
              width: "100%",
              maxWidth: "100vw",
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              pt: 4,
              px: isSmallScreen ? "20px" : 3,

              "& *": {
                transition: "color 0.2s ease, background-color 0.2s ease",
              },
            }}
            ref={contentRef}
          >
            {isMobile && (
              <Button
                startIcon={<ArrowBackIcon />}
                disableRipple
                disableElevation
                sx={{
                  fontFamily: "Inter700",
                  fontSize: "calc(18px + var(--font-delta))",
                  fontWeight: "bold",
                  color: "#1B1B1B",
                  textTransform: "none",
                  mb: 2,
                  width: "100%",
                  justifyContent: "flex-start",
                  pl: 1,

                    backgroundColor: "transparent",
                  "&:focus": {
                    outline: "none",
                    backgroundColor: "transparent",
                  },
                }}
                  onClick={() => window.location.assign("/learn-research/blog-news")}
              >
                Back to Blog Home
              </Button>
            )}
            {/* Sidebar - TOC - Hidden on small screens */}
            {!isMobile && toc.length > 0 && (
              <Grid2
                sx={{
                  position: "sticky",
                  alignSelf: "flex-start",
                  top: "55px",
                  height: "fit-content",
                  mb: 0,
                  pr: "2px",
                  width: "auto",
                  maxWidth: isMediumScreen ? "250px" : "350px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    borderRadius: "8px",
                    maxHeight: tocMaxHeight,
                    overflowY: tocMaxHeight !== "auto" ? "auto" : "visible",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#0B1420",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent",
                    },
                    scrollbarWidth: "thin",
                    scrollbarColor: "#0B1420 transparent",
                  }}
                >
                  <Button
                    startIcon={<ArrowBackIcon />}
                    disableRipple
                    disableElevation
                    sx={{
                      fontFamily: "Inter700",
                      fontSize: "calc(18px + var(--font-delta))",
                      fontWeight: "bold",
                      color: "#000000",
                      textTransform: "none",
                      mb: 2,
                      width: "100%",
                      justifyContent: "flex-start",
                      pl: 1,
                      position: tocMaxHeight ? "sticky" : "",
                      top: 0,
                      background: "#ffffff",

                        backgroundColor: "transparent",

                      "&:focus": {
                        outline: "none",
                        backgroundColor: "transparent",
                      },
                    }}
                      onClick={() => window.location.assign("/learn-research/blog-news")}
                  >
                    Back to Blog Home
                  </Button>

                  <Typography
                    sx={{
                        fontSize: "calc(20px + var(--font-delta)) !important",
                      fontWeight: "bold !important",
                      color: "#000000 !important",
                      fontFamily: "Inter600 !important",
                      mb: 1,
                    }}
                  >
                    Table of Contents
                  </Typography>

                  {/* TOC Items */}
                  <Box
                    sx={{
                      overflowY: tocMaxHeight !== "auto" ? "auto" : "visible",
                      pr: 1,
                      padding:"0px 15px 10px 0px"
                    }}
                  >
                    {toc.map((item) => (

                      <Typography
                        key={item.id}
                        onClick={() => scrollToSection(item.id)}
                        sx={{
                          cursor: "pointer",
                          fontSize: "calc(15px + var(--font-delta))",
                          color: "#1B1B1B !important",
                          fontWeight:
                            activeHeading === item.id ? "700" : "400",
                          "&:hover": {
                            color: "#1B1B1B !important",
                            fontWeight: "700",
                          },
                          mt: 1,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                          padding: "6px 8px",
                          borderRadius: "4px",
                          fontFamily:
                            activeHeading === item.id
                              ? "Inter600"
                              : "Inter400",
                          backgroundColor: "transparent",
                          // boxShadow: activeHeading === item.id
                          //   ? "0px 1px 10px 10px #14C2F233"
                          //   : "none",
                          ml:
                            item.tag === "h2" ? 2 : item.tag === "h3" ? 4 : 0,
                        }}
                      >
                        <img
                          src={toc_svg}
                          alt="toc"
                          style={{
                            width: "14px",
                            filter:
                              activeHeading === item.id
                                ? "invert(48%) sepia(79%) saturate(2476%) hue-rotate(202deg) brightness(98%) contrast(93%)"
                                : "brightness(0.6)",
                            transition: "filter 0.2s ease",
                          }}
                        />
                        <span>{item.text}</span>
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </Grid2>
            )}

            {/* Main Content */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
              }}
            >
              {/* Blog Image */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                }}
              >
                <img
                  src={
                    isSmallScreen
                      ? blog?.blog_thumbnail_small_screen
                      : blog?.blog_thumbnail_big_screen
                  }
                  alt="Blog Thumbnail"
                  style={{
                    width: "100%",
                    height: "auto",
                  }}
                />
              </Box>

              {/* Tags (Left) & Meta Info (Right) */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  fontFamily: "cardiuma-M",
                  mb: 4,
                  gap: 2,
                }}
              >
                {/* Tags (Left) */}
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {blog?.blog_tags?.map((tag, index) => (
                    <Box
                      key={index}
                      sx={{
                        color: "# !important",
                        fontSize: "calc(15px + var(--font-delta))",
                       fontFamily:"Inter400",
                        lineHeight: "18px",
                      }}
                    >
                      • {tag}
                    </Box>
                  ))}
                </Box>

                {/* Time to Read + Created Date (Right) */}
                <Box
                  sx={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                      fontSize: "calc(15px + var(--font-delta))",
                      color: "#1B1B1B !important",
                    textAlign: "center",
                    fontWeight: "600px !important",
                    lineHeight: "18px",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#1B1B1B !important",
                      display: "flex",
                      alignItems: "center",
                      fontSize:"calc(13px + var(--font-delta))"
                    }}
                  >
                    <AccessTimeFilledIcon
                      sx={{ width: "17px", height: "17px", mr: 1 }}
                    />{" "}
                    10 min read
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#1B1B1B !important",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "calc(13px + var(--font-delta))"
                    }}
                  >
                    <CalendarTodayIcon
                      sx={{ width: "17px", height: "17px", mr: 1 }}
                    />{" "}
                    {formatDate(blog?.created_at)}
                  </Typography>
                </Box>
              </Box>

              {/* Blog Content */}
              <div
                dangerouslySetInnerHTML={{
                  __html: `
                  <style>
                   #blog-content-container ol {
                      counter-reset: item;
                      font-weight: 900 !important;
                      padding-left: 20px !important;
                    }
                    #blog-content-container ol li {
                      list-style-type: none;
                      font-weight: 900 !important;
                      font-size: 20px !important;
                    }
                    #blog-content-container ol li:before {
                      counter-increment: item;
                      content: counter(item) ". ";
                      font-weight: 900 !important;
                      color: black;
                      font-family: 'cardiuma-Bold' !important;
                    }

                    #blog-content-container h1{
                    }
                    #blog-content-container h2,
                    #blog-content-container h3 {
                      margin-top:30px;
                      margin-bottom:15px;
                      line-height: 1.4 !important;
                    }

                    #blog-content-container h1,
                    #blog-content-container h2,
                    #blog-content-container h3,
                    #blog-content-container strong:not(a strong),
                    #blog-content-container b:not(a b) {

                      font-family: 'Outfit400' !important;
                      color: #000000 !important;
                      line-height: 100% !important;

                    }

                    #blog-content-container b:not(a b) {
                      font-weight: 900 !important;
                      font-family: 'cardiuma-Bold' !important;
                      line-height: 1.4 !important;
                    }

                    #blog-content-container p,
                    #blog-content-container div,
                    #blog-content-container li {
                      font-family: 'Inter400' !important;
                      color: #1B1B1B !important;
                      line-height: 38px !important;
                    }


                    #blog-content-container ul li::marker {
                      font-weight: 900 !important;
                      font-size: 1em;
                      color: white;
                      font-family: 'cardiuma-Bold' !important;
                    }
                    #blog-content-container ul {
                      padding-left: 14px !important;
                    }

                    #blog-content-container i:not(a i),
                    #blog-content-container em:not(a em) {
                      font-family: 'cardiuma-regular' !important;
                      color: ##6B7280 !important;
                      font-style: italic !important;
                      line-height: 1.6 !important;
                    }

                    @media (max-width: 900px) {
                      #blog-content-container h1 { font-size: 1.75rem; }
                      #blog-content-container h2 { font-size: 1.5rem; }
                      #blog-content-container h3 { font-size: 1.25rem; }
                      #blog-content-container p { line-height: 30px !important; font-size:1.25rem !important }
                       #blog-content-container li { font-size: 1.25rem;}
                    }
                    @media (max-width: 600px) {
                      #blog-content-container h1 { font-size: 1.5rem; }
                      #blog-content-container h2 { font-size: 1.25rem; }
                      #blog-content-container h3 { font-size: 1rem; }
                      #blog-content-container p { line-height: 28px !important;  }
                    }
                       @media (max-width: 425px) {
                      #blog-content-container h1 { font-size: 1.5rem; }
                      #blog-content-container h2 { font-size: 1.25rem; }
                      #blog-content-container h3 { font-size: 1rem; }
                     #blog-content-container p {
                      line-height: 25px !important;
                      font-size: 10px !important;
                     }
                     #blog-content-container li {
                      font-size: 0.75rem !important;  /* Keep list font consistent */
                       line-height: 25px !important;
                     }
                    }
                  </style>
                  <div id="blog-content-container">${htmlBody}</div>`,
                }}
              />
            </Box>

            {/* Right Sidebar - Social & Ads - Only show on large screens */}
            {/* {isLargeScreen && (
              <Box
                sx={{
                  position: "sticky",
                  alignSelf: "flex-start",
                  top: "66px",
                  height: "fit-content",
                  pl: 2,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    p: 3,
                    borderRadius: "12px",
                    mb: 4,
                    border: "1px solid #1E2D3D",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      mb: 2,
                      textAlign: "center",
                      fontFamily: "cardiuma-Bold",
                    }}
                  >
                    Did you like this article?
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#999999",
                      mb: 3,
                      textAlign: "center",
                      fontFamily: "cardiuma-SemiBold",
                    }}
                  >
                    Share it!
                  </Typography>


                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                    }}
                  >
                    <IconButton
                      onClick={() => shareOnSocialMedia("twitter")}
                      aria-label="share on Twitter"
                    >
                      <TwitterIcon sx={{ color: "#999999" }} />
                    </IconButton>

                    <Tooltip title="Share to Instagram Story" arrow>
                      <IconButton
                        onClick={() => shareOnSocialMedia("instagram")}
                        aria-label="share on Instagram Story"
                      >
                        <InstagramIcon sx={{ color: "#999999" }} />
                      </IconButton>
                    </Tooltip>
                    <IconButton
                      onClick={() => shareOnSocialMedia("facebook")}
                      aria-label="share on Facebook"
                    >
                      <FacebookIcon sx={{ color: "#999999" }} />
                    </IconButton>
                    <IconButton
                      onClick={() => shareOnSocialMedia("linkedin")}
                      aria-label="share on LinkedIn"
                    >
                      <LinkedInIcon sx={{ color: "#999999" }} />
                    </IconButton>
                  </Box>
                </Box>


              </Box>
            )} */}
          </Grid2>


          <Box sx={{ width: "100%", maxWidth: "100vw", overflowX: "hidden" }}>
            <MoreBlogs />
          </Box>



        </Grid2>

      </>
  </Grid2 >

    </main>)
}